import { gql } from '@apollo/client';

export default gql`
    mutation updateTermsMutation($settings: JSON) {
        data: updateSystemSettings(section: terms, settings: $settings)
    }
`;
